import React, { useState, useEffect } from "react";
import { Alert, Box, Button } from "@mui/material/";
import { useTranslation } from "react-i18next";
import { useToaster } from "../common/hooks";
import { useNavigate } from "react-router-dom";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CameraAltIcon from "@mui/icons-material/CameraAlt";

import makeStyles from "@mui/styles/makeStyles";
import styles from "./styles.js";
import config from "../config";
import { logToSentry } from "../config/Sentry";

const DeviceSystemPermissions = ({ setPermissions }) => {
    const classes = makeStyles(styles)();
    const { t } = useTranslation();
    const toast = useToaster();
    const navigate = useNavigate();

    const [location, setLocation] = useState(true);
    const [camera, setCamera] = useState(true);

    const displayError = (error) => {
        console.log(error);
        toast.error(error);
        logToSentry("DeviceSystemPermissions:displayError", {
            error,
        });
    };

    async function checkCameraAndLocationPermissions() {
        // Check if the browser supports camera
        // TODO: Disabled will be removed in the future
        // if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        //     displayError(t("messages.cameraIsNotAvailable"));
        // } else {
        //     try {
        //         // Check if the user has granted permission to access the camera
        //         const cameraPermission = await navigator.permissions.query({
        //             name: "camera",
        //         });
        //         if (cameraPermission.state === "denied") {
        //             setCamera(false);
        //         } else if (cameraPermission.state === "granted") {
        //             setCamera(true);
        //         }
        //     } catch (error) {
        //         displayError(t("messages.noCameraPermission") + error);
        //     }
        // }

        // Check if the browser supports geolocation
        if (!navigator.geolocation) {
            displayError(t("messages.locationIsNotAvailable"));
        } else {
            try {
                // Check if the user has granted permission to access the geolocation
                const locationPermission = await navigator.permissions.query({
                    name: "geolocation",
                });
                if (locationPermission.state === "denied") {
                    setLocation(false);
                } else if (locationPermission.state === "granted") {
                    setLocation(true);
                }
            } catch (error) {
                displayError(t("messages.noLocationPermission") + error);
            }
        }
    }

    useEffect(() => {
        checkCameraAndLocationPermissions();
    }, []);

    useEffect(() => {
        const permissions = camera && location;
        setPermissions(permissions);
    }, [location, camera]);

    const RenderMessage = ({ icon, message }) => {
        return (
            <Alert
                severity="error"
                iconMapping={{
                    error:
                        icon === "location" ? (
                            <LocationOnIcon fontSize="inherit" />
                        ) : (
                            <CameraAltIcon fontSize="inherit" />
                        ),
                }}
                className={classes.alert}
            >
                {message}
            </Alert>
        );
    };

    return (
        <Box className={classes.systemPermissionsContainer}>
            {!location && (
                <RenderMessage
                    icon="location"
                    message={t("messages.locationDisabled")}
                />
            )}
            {/* {!camera && (
                <RenderMessage
                    icon="camera"
                    message={t("messages.cameraDisabled")}
                />
            )} */}
            {(!camera || !location) && (
                <Button
                    variant="outlined"
                    onClick={() => navigate(config.permissionsReadme)}
                    color="error"
                    className={classes.readme}
                >
                    {`${t("tapForReadme")} README`}
                </Button>
            )}
        </Box>
    );
};

export default DeviceSystemPermissions;
